import { useCallback, useEffect } from 'react'
import { useSelector } from '@/libs/state'
import { getMember } from '../application/get-member'
import { activeMember$ } from '../store'
import { members as membersPort, notify } from '../wiring'

const useMember = (id: string | null) => {
	const member = useSelector(activeMember$)

	const reload = useCallback(async () => {
		if (!id) {
			activeMember$.set(null)
			return
		}
		const result = await getMember(membersPort, id, notify)
		activeMember$.set(result)
	}, [id])

	useEffect(() => {
		reload()
	}, [reload])

	return { member, reload }
}

export { useMember }
